import React, { useEffect, useState } from "react";
import { Button } from "components/Shared";

interface HeaderButtonProps {
  text: string;
  getButtonControlMethods: (cm: HeaderButtonControlMethods) => void;
  onClick: () => void;
}

export interface HeaderButtonControlMethods {
  setText: (text: string) => void;
}

// The point of this component is to provide a button where the text can be controlled externally.
// When a button is added to the header, it's above the component that created it in the tree so it can't receive updated props.
// By using this button you can control its text via a ref. To implement it, add the button to the header using the Control prop in the button array object
const HeaderButton = ({ text, getButtonControlMethods, onClick }: HeaderButtonProps) => {
  const [buttonText, setButtonText] = useState(text);

  const controlMethods: HeaderButtonControlMethods = {
    setText: setButtonText,
  };

  useEffect(() => {
    getButtonControlMethods(controlMethods);
  }, []);

  return (
    <Button onClick={onClick}>
      {buttonText}
    </Button>
  );
};

export default HeaderButton;